import {
    CheckCircleRounded as CheckCircleIcon,
    PixRounded as PixRoundedIcon,
    CreditCardRounded as CreditCardRoundedIcon,
    LocalAtmRounded as LocalAtmRoundedIcon,
    PointOfSaleRounded as PointOfSaleIcon
} from '@mui/icons-material'

import {getLocal, getSession} from '../../../hooks/useStorage/useStorage.jsx'

import {paymentMethods as textsPaymentMethods, general as textsGeneral} from '../../../translate/Translate.jsx'
import {motion} from 'framer-motion'

import './paymentTypes.scss'
import {CardMedia} from "@mui/material";
import gpay from '../../../assets/g-pay.svg'

const PaymentTypes = ({onClick}) => {
    const totem = getLocal('totem', false)
    const payment = getSession('payment', {})
    const paymentTypes = getLocal('paymentTypes', [])
    const deliveryMode = getLocal('deliveryMode')
    const cashPayments = getLocal('cashPayments')
    const physicalPayments = getLocal('physicalPayments')
    const onlinePayments = getLocal('onlinePayments')
    const online = paymentTypes.filter((p) => (p.online === 'True'))
    const physical = paymentTypes.filter((p) => (p.online === 'False'))
    const typesOnline = []
    const typesPhysical = []
    physical.forEach((p) => {
        if (p.code === 'DIN') {
            if (cashPayments === 'ALL') {
                typesPhysical.push(p)
            } else if (cashPayments === 'TAKEAWAY' && deliveryMode === 'takeaway') {
                typesPhysical.push(p)
            } else if (cashPayments === 'DELIVERY' && deliveryMode === 'delivery') {
                typesPhysical.push(p)
            }
        } else {
            if (physicalPayments === 'ALL') {
                typesPhysical.push(p)
            } else if (physicalPayments === 'TAKEAWAY' && deliveryMode === 'takeaway') {
                typesPhysical.push(p)
            } else if (physicalPayments === 'DELIVERY' && deliveryMode === 'delivery') {
                typesPhysical.push(p)
            }
        }
    })
    const onlineFilter = online.filter((o) => (o.code === 'PIX'))
    if (online.length > 1) onlineFilter.push({
        code: 'ONLINE',
        description: 'Pagamento online',
        online: 'True'
    })
    onlineFilter.forEach((o) => {
        if (onlinePayments === 'ALL' || o.code === 'PIX') {
            typesOnline.push(o)
        } else if (onlinePayments === 'TAKEAWAY' && deliveryMode === 'takeaway') {
            typesOnline.push(o)
        } else if (onlinePayments === 'DELIVERY' && deliveryMode === 'delivery') {
            typesOnline.push(o)
        }
    })

    // typesOnline.push({
    //     code: "G-PAY",
    //     description: "Google Pay",
    //     online: "True"
    // })

    const handleClickTotem = (type) => {
        const payment = {
            code: (type === 'pix') ? 'PIX' : 'DIN',
            description: (type === 'pix') ? 'Pix' : 'Dinheiro',
            online: (type === 'pix') ? 'True' : 'False'
        }
        onClick(payment)
    }

    if (totem) return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        exit={{x: 400, opacity: 0}}
        transition={{duration: 0.3}}>
        <div className={'payments-types'}>
            <div className={'div-payments-types'}>
                <div className={'div-title'}>
                    <label className={'label-title-payments-types'}>
                        {textsGeneral.payment}
                    </label>
                </div>
                <div
                    className={'div-types'}
                    onClick={() => handleClickTotem('pix')}
                    id={(payment?.code === 'PIX') ? 'div-types-selected' : ''}>
                    <div className={'div-item-types'}>
                        <div className={'div-description-type'}>
                            <PixRoundedIcon className={'icon-pix'}/>
                            <label className={'label-description-payments-types'}>
                                {textsPaymentMethods.pix}
                            </label>
                        </div>
                        <div className={'div-seleted-type'}>
                            <CheckCircleIcon
                                className={'icon-select-option'}
                                id={(payment?.code === 'PIX') ? 'icon-selected-types' : ''}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className={'div-types'}
                    onClick={() => handleClickTotem('counter')}
                    id={(payment?.code === 'DIN') ? 'div-types-selected' : ''}>
                    <div className={'div-item-types'}>
                        <div className={'div-description-type'}>
                            <PointOfSaleIcon className={'icon-payment-physical'}/>
                            <label className={'label-description-payments-types'}>
                                {textsPaymentMethods.payCounter}
                            </label>
                        </div>
                        <div className={'div-seleted-type'}>
                            <CheckCircleIcon
                                className={'icon-select-option'}
                                id={(payment?.code === 'DIN') ? 'icon-selected-types' : ''}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </motion.div>

    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        exit={{x: 400, opacity: 0}}
        transition={{duration: 0.3}}>
        <div className={'payments-types'}>
            {(!!typesOnline.length) && <div className={'div-payments-types'}>
                <div className={'div-title'}>
                    <label className={'label-title-payments-types'}>
                        {textsPaymentMethods.onlinePayment}
                    </label>
                </div>
                {typesOnline.map((t, i) => {
                    if (totem && t.code !== 'PIX') return null
                    return <div
                        key={i}
                        onClick={() => onClick(t)}
                        className={'div-types'}
                        id={(payment?.code === t.code) ? 'div-types-selected' : ''}>
                        <div className={'div-item-types'}>
                            <div className={'div-description-type'}>
                                {(() => {
                                    if (t.code === 'PIX')
                                        return <PixRoundedIcon className={'icon-pix'}/>
                                    if (t.code === 'G-PAY')
                                        return <CardMedia image={gpay} className={'icon-g-pay'}/>
                                    else
                                        return <CreditCardRoundedIcon className={'icon-payment-online'}/>
                                })()}
                                <label className={'label-description-payments-types'}>
                                    {t.description}
                                </label>
                            </div>
                            <div className={'div-seleted-type'}>
                                <CheckCircleIcon
                                    className={'icon-select-option'}
                                    id={(payment.code === t.code) ? 'icon-selected-types' : ''}
                                />
                            </div>
                        </div>
                    </div>
                })}
            </div>}
            {(!!typesPhysical.length) && <div className={'div-payments-types'}>
                <div className={'div-title'}>
                    <label className={'label-title-payments-types'}>
                        {textsPaymentMethods.physicalPayment}
                    </label>
                </div>
                {typesPhysical.map((t, i) => {
                    if (totem && t.code !== 'DIN') return null
                    return <div
                        key={i}
                        onClick={() => onClick(t)}
                        className={'div-types'}
                        id={(payment.code === t.code) ? 'div-types-selected' : ''}>
                        <div className={'div-item-types'}>
                            <div className={'div-description-type'}>
                                {(() => {
                                    if (t.code === 'DIN')
                                        return <LocalAtmRoundedIcon className={'icon-cash'}/>
                                    else
                                        return <CreditCardRoundedIcon className={'icon-payment-physical'}/>
                                })()}
                                <label className={'label-description-payments-types'}>
                                    {t.description}
                                </label>
                            </div>
                            <div className={'div-seleted-type'}>
                                <CheckCircleIcon
                                    className={'icon-select-option'}
                                    id={(payment.code === t.code) ? 'icon-selected-types' : ''}/>
                            </div>
                        </div>
                    </div>
                })}
            </div>}
        </div>
    </motion.div>
}

export default PaymentTypes
